import React, { Component } from 'react';
import {connect} from 'react-redux'
import axios from 'axios';
import { 
    showMessage, showCustomMessage, hideCustomMessage
} from '../actions/popupMessageActions';
import CryptoJS from 'crypto-js';
const baseURL = process.env.REACT_APP_DASHBOARD_API_URL;



class ModalNotificationSettings extends Component {
    state = { 
        show: false,
        switchedOn: false,
        isProcessing: false,
        isLoading: true,
        updateResult: "",
        showResult: false,
        errorMessage: "",
    }
    componentDidMount() {
        
    }

    // JWT signing function using crypto-js with proper base64url encoding
    signJWT = (payload, secret) => {
        const header = {
            alg: 'HS256',
            typ: 'JWT'
        };
        
        // Convert to base64url (JWT standard)
        const encodedHeader = btoa(JSON.stringify(header))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=/g, '');
        
        const encodedPayload = btoa(JSON.stringify(payload))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=/g, '');
        
        // Use secret as raw string and convert to Base64URL manually
        const signature = CryptoJS.HmacSHA256(
            encodedHeader + '.' + encodedPayload,
            secret
        ).toString(CryptoJS.enc.Base64)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=/g, '');
        
        return encodedHeader + '.' + encodedPayload + '.' + signature;
    };

    generatePanaLoginUrl = () => {
        try {
            // Use raw string secret (not Base64-encoded)
            const JWT_SECRET = process.env.REACT_APP_JWT_SECRET;
            const JWT_ISSUER = process.env.REACT_APP_JWT_ISSUER;
            const JWT_AUDIENCE = process.env.REACT_APP_JWT_AUDIENCE;
            const PANA_BASE_URL = process.env.REACT_APP_PANA_BASE_URL;
            const now = Math.floor(Date.now() / 1000); // current time in seconds
            
            if(!JWT_SECRET || !JWT_ISSUER || !JWT_AUDIENCE || !PANA_BASE_URL) {
                return null;
            }

            console.log(JWT_SECRET);
            console.log(this.props.accId);
            const payload = {
                iss: JWT_ISSUER,
                aud: JWT_AUDIENCE,
                iat: now,
                exp: now + 60 * 30, // valid for 30 mins
                account_id: this.props.accId,
            };
            
            const token = this.signJWT(payload, JWT_SECRET);
            console.log(token);
            // Construct URL - Using the specified endpoint
            const url = `${PANA_BASE_URL}/oauth/login?token=${token}`;
            
            return url;
        } catch(error) {
            console.error("JWT generation error:", error);
            return null;
        }
    }

    getCurrentSetting = () => {
        axios.post(baseURL+'/generate-token',
        {
            accountId: this.props.accId,
            division: 'GPA'
        },
        {
            headers: {
            'Content-Type': 'application/json',
            },
        })
        .then(response => {
            const result = response.data.result;
            const routeType = result.details.billRouteType
            this.setState({
                switchedOn: routeType === "POSTAL" ? false : true,
                isLoading: false
            })
        })
        .catch(error => {
            this.props.showMessage(true, "Server Error! ");
        });
    }
    generateToken = (e) => {
        this.props.showCustomMessage(true, "Please wait ...");
        
        const url = this.generatePanaLoginUrl();
        
        if (url) {
            // Open the URL in a new tab
            window.open(url, '_blank');
            this.props.hideCustomMessage();
        } else {
            this.props.hideCustomMessage();
            this.props.showMessage(true, "Failed to generate login URL");
        }
        
        // axios.post('https://gpwatest.prithibiconsulting.com/oauth/login?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxMjM0NSIsInJvbGUiOiJhZG1pbiIsImlhdCI6MTc1Njc5ODc0MCwiZXhwIjoxNzU2ODAyMzQwLCJpc3MiOiJwYXlncGEiLCJhdWQiOiJwYW5hIn0.QNpQN31WMayXsihBTAW1s3RKjiaFeJYyoPh9tJn4oHg',
        //     {
        //         accountId: this.props.accId,
        //         division: 'GPA'
        //     },
        //     {
        //         headers: {
        //             'Content-Type': 'application/json',
        //             'Authorization': 'Bearer'
        //         },
        //     })
        //     .then(response => {
        //         this.props.hideCustomMessage(true, "");
        //         const result = response.data.result;
        //         const routeType = result.details.billRouteType
        //         this.setState({
        //             switchedOn: routeType === "POSTAL" ? false : true,
        //             isLoading: false
        //         })
        //     })
        //     .catch(error => {
        //         this.props.hideCustomMessage(true, "");
        //         this.props.showMessage(true, "Server Error! ");
        //     });
    }
    render() { 
        return (  
            <React.Fragment>
                <p style={{margin: "0"}} onClick={this.generateToken.bind(this)}><img src={process.env.PUBLIC_URL + '/images/gear.png'} width="15px"/> Notification Settings</p>
            </React.Fragment>
        );
    }
}
 
const mapStateToProps = state => ({
    dashboard: state.dashboard
});

export default connect(mapStateToProps, 
{ 
    showMessage, showCustomMessage, hideCustomMessage 
})(ModalNotificationSettings);